import {hitGoogleTagManager} from "../../../../tracking/google_tag_manager/hit_google_tag_manager";

const TINDER_MULTI_LEAD_MODAL_GTM_EVENT = "modal_multilead_tinder";
const TINDER_MULTI_LEAD_TOPIC_GTM_EVENT = "multilead_tinder_topic";
const TINDER_MULTI_LEAD_SUMMARY_GTM_EVENT = "multilead_tinder_summary";

/** Step-3 review deck modal ("Przejrzyj i zapytaj"). */
export const hitTinderMultiLeadModalGtmEvent = (params: {action: "view" | "close"} | {action: "click"; clickText: string}) => {
    hitGoogleTagManager({
        event: TINDER_MULTI_LEAD_MODAL_GTM_EVENT,
        event_action: params.action,
        ...(params.action === "click" ? {event_label: params.clickText} : {})
    });
};

/** Topic selection bottom sheet ("Chcę zapytać o:"). */
export const hitTinderMultiLeadTopicGtmEvent = (params: {action: "view" | "close"} | {action: "submit"; selectedOptions: string[]}) => {
    hitGoogleTagManager({
        event: TINDER_MULTI_LEAD_TOPIC_GTM_EVENT,
        event_action: params.action,
        ...(params.action === "submit" ? {event_label: params.selectedOptions.join(", ")} : {})
    });
};

/** Sent-applications summary step; `custom_label` carries the number of sent inquiries. */
export const hitTinderMultiLeadSummaryGtmEvent = (params: ({action: "view" | "close"} | {action: "click"; clickText: string}) & {offersCount: number}) => {
    hitGoogleTagManager({
        event: TINDER_MULTI_LEAD_SUMMARY_GTM_EVENT,
        event_action: params.action,
        ...(params.action === "click" ? {event_label: params.clickText} : {}),
        custom_label: String(params.offersCount)
    });
};
import {hitGoogleTagManager} from "../../../../tracking/google_tag_manager/hit_google_tag_manager";

const TINDER_MULTI_LEAD_MODAL_GTM_EVENT = "modal_multilead_tinder";
const TINDER_MULTI_LEAD_TOPIC_GTM_EVENT = "multilead_tinder_topic";
const TINDER_MULTI_LEAD_SUMMARY_GTM_EVENT = "multilead_tinder_summary";

/** Step-3 review deck modal ("Przejrzyj i zapytaj"). */
export const hitTinderMultiLeadModalGtmEvent = (params: {action: "view" | "close"} | {action: "click"; clickText: string}) => {
    hitGoogleTagManager({
        event: TINDER_MULTI_LEAD_MODAL_GTM_EVENT,
        event_action: params.action,
        ...(params.action === "click" ? {event_label: params.clickText} : {})
    });
};

/** Topic selection bottom sheet ("Chcę zapytać o:"). */
export const hitTinderMultiLeadTopicGtmEvent = (params: {action: "view" | "close"} | {action: "submit"; selectedOptions: string[]}) => {
    hitGoogleTagManager({
        event: TINDER_MULTI_LEAD_TOPIC_GTM_EVENT,
        event_action: params.action,
        ...(params.action === "submit" ? {event_label: params.selectedOptions.join(", ")} : {})
    });
};

/** Sent-applications summary step; `custom_label` carries the number of sent inquiries. */
export const hitTinderMultiLeadSummaryGtmEvent = (params: ({action: "view" | "close"} | {action: "click"; clickText: string}) & {offersCount: number}) => {
    hitGoogleTagManager({
        event: TINDER_MULTI_LEAD_SUMMARY_GTM_EVENT,
        event_action: params.action,
        ...(params.action === "click" ? {event_label: params.clickText} : {}),
        custom_label: String(params.offersCount)
    });
};
